export interface NavItem {
  label: string;
  href: string;
}

export const navItems: NavItem[] = [
  { label: "首页", href: "#top" },
  { label: "电影", href: "#updates" },
  { label: "电视剧", href: "#updates" },
  { label: "综艺", href: "#collections" },
  { label: "动漫", href: "#collections" },
  { label: "纪录片", href: "#collections" },
  { label: "排行榜", href: "#rankings" },
  { label: "专题", href: "#collections" },
];

export interface TickerItem {
  title: string;
  episode: string;
  time: string;
}

export const tickerItems: TickerItem[] = [
  { title: "雾都迷踪", episode: "更新至 12 集", time: "3 分钟前" },
  { title: "山海秘境", episode: "第 8 集上线", time: "11 分钟前" },
  { title: "铁血长空", episode: "高清完整版", time: "26 分钟前" },
  { title: "春日便当店", episode: "更新至 20 集", time: "40 分钟前" },
  { title: "青铜时代", episode: "第 5 集", time: "1 小时前" },
  { title: "深海回声", episode: "全集开放", time: "1 小时前" },
  { title: "风起南城", episode: "更新至 9 集", time: "2 小时前" },
  { title: "第七号档案", episode: "第 3 集", time: "2 小时前" },
];

export interface QuickEntry {
  name: string;
  desc: string;
  icon: string;
  href: string;
  tone: "primary" | "accent" | "secondary";
}

export const quickEntries: QuickEntry[] = [
  { name: "热播剧集", desc: "追更不断档", icon: "ri-play-circle-line", href: "#updates", tone: "primary" },
  { name: "电影专区", desc: "大片抢先看", icon: "ri-film-line", href: "#updates", tone: "accent" },
  { name: "综艺漫游", desc: "轻松下饭", icon: "ri-mic-2-line", href: "#collections", tone: "secondary" },
  { name: "专题合集", desc: "按主题找片", icon: "ri-stack-line", href: "#collections", tone: "primary" },
  { name: "今日榜单", desc: "大家都在看", icon: "ri-bar-chart-2-line", href: "#rankings", tone: "accent" },
  { name: "剧迷热评", desc: "聊聊看点", icon: "ri-chat-smile-2-line", href: "#discussions", tone: "secondary" },
];

export interface HeroFeature {
  title: string;
  subtitle: string;
  cover: string;
  score: string;
  badge: string;
  meta: string;
  tags: string[];
  desc: string;
}

export const heroFeature: HeroFeature = {
  title: "雾都迷踪",
  subtitle: "年度口碑悬疑 · 全网独家上线",
  cover:
    "https://readdy.ai/api/search-image?query=Epic%20cinematic%20hero%20banner%20of%20a%20rainy%20noir%20city%20at%20night%20with%20glowing%20neon%20signs%20and%20a%20lone%20silhouette%20in%20a%20long%20coat%2C%20dramatic%20moody%20lighting%2C%20rich%20cinematic%20color%20grading%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=1280&height=760&seq=jj-hero-01&orientation=landscape",
  score: "9.2",
  badge: "独家首播",
  meta: "2026 · 中国大陆 · 悬疑 / 犯罪",
  tags: ["高能反转", "群像演技", "一口气看完"],
  desc:
    "一场横跨三城的连环旧案，让蛰伏多年的前刑警再度回到雨雾弥漫的都市。层层抽丝剥茧，真相比夜色更难辨认。",
};

export interface HotRankItem {
  rank: number;
  title: string;
  episode: string;
  score: string;
}

export const heroHotList: HotRankItem[] = [
  { rank: 1, title: "雾都迷踪", episode: "更新至 12 集", score: "9.2" },
  { rank: 2, title: "山海秘境", episode: "更新至 8 集", score: "9.0" },
  { rank: 3, title: "铁血长空", episode: "高清完整版", score: "8.8" },
  { rank: 4, title: "春日便当店", episode: "更新至 20 集", score: "8.7" },
  { rank: 5, title: "深海回声", episode: "全集开放", score: "8.6" },
];

export interface UpdateItem {
  id: string;
  title: string;
  cover: string;
  category: string;
  episode: string;
  score: string;
  time: string;
  tags: string[];
}

export const updateItems: UpdateItem[] = [
  {
    id: "u01",
    title: "雾都迷踪",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20rainy%20neon%20city%20night%20noir%20with%20a%20lone%20trench%20coat%20silhouette%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-01&orientation=portrait",
    category: "电视剧",
    episode: "更新至 12 集",
    score: "9.2",
    time: "3 分钟前",
    tags: ["悬疑", "犯罪"],
  },
  {
    id: "u02",
    title: "山海秘境",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20an%20ancient%20chinese%20fantasy%20mountain%20realm%20with%20floating%20islands%20and%20mist%2C%20dramatic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-02&orientation=portrait",
    category: "国漫",
    episode: "更新至 8 集",
    score: "9.0",
    time: "11 分钟前",
    tags: ["古装", "奇幻"],
  },
  {
    id: "u03",
    title: "铁血长空",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20fighter%20jet%20soaring%20through%20dramatic%20sunset%20clouds%2C%20heroic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-03&orientation=portrait",
    category: "电影",
    episode: "高清完整版",
    score: "8.8",
    time: "26 分钟前",
    tags: ["动作", "军事"],
  },
  {
    id: "u04",
    title: "春日便当店",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20sunlit%20warm%20bento%20shop%20with%20steaming%20home%20style%20dishes%20and%20soft%20daylight%2C%20cozy%20gentle%20mood%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-04&orientation=portrait",
    category: "电视剧",
    episode: "更新至 20 集",
    score: "8.7",
    time: "40 分钟前",
    tags: ["治愈", "美食"],
  },
  {
    id: "u05",
    title: "青铜时代",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20vast%20ancient%20battlefield%20with%20war%20banners%20under%20a%20golden%20sunset%2C%20epic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-05&orientation=portrait",
    category: "电视剧",
    episode: "更新至 5 集",
    score: "8.5",
    time: "1 小时前",
    tags: ["历史", "史诗"],
  },
  {
    id: "u06",
    title: "深海回声",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20deep%20ocean%20abyss%20with%20glowing%20bioluminescent%20creatures%2C%20mysterious%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-06&orientation=portrait",
    category: "纪录片",
    episode: "全集开放",
    score: "8.6",
    time: "1 小时前",
    tags: ["自然", "科普"],
  },
  {
    id: "u07",
    title: "风起南城",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%201930s%20shanghai%20street%20with%20vintage%20cars%20and%20old%20street%20lamps%20in%20mist%2C%20nostalgic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-07&orientation=portrait",
    category: "电视剧",
    episode: "更新至 9 集",
    score: "8.4",
    time: "2 小时前",
    tags: ["民国", "谍战"],
  },
  {
    id: "u08",
    title: "第七号档案",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20dim%20archive%20room%20with%20stacks%20of%20old%20files%20and%20a%20single%20desk%20lamp%2C%20mysterious%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-08&orientation=portrait",
    category: "网剧",
    episode: "更新至 3 集",
    score: "8.3",
    time: "2 小时前",
    tags: ["悬疑", "烧脑"],
  },
  {
    id: "u09",
    title: "时光邮局",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20quiet%20old%20post%20office%20with%20warm%20afternoon%20sunlight%20and%20letters%2C%20nostalgic%20gentle%20mood%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-09&orientation=portrait",
    category: "电影",
    episode: "高清完整版",
    score: "8.9",
    time: "3 小时前",
    tags: ["爱情", "奇幻"],
  },
  {
    id: "u10",
    title: "霓虹晚风",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20modern%20city%20rooftop%20at%20dusk%20with%20warm%20neon%20glow%20and%20two%20distant%20figures%2C%20romantic%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-10&orientation=portrait",
    category: "电视剧",
    episode: "更新至 16 集",
    score: "8.2",
    time: "4 小时前",
    tags: ["都市", "甜宠"],
  },
  {
    id: "u11",
    title: "归途",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20long%20empty%20country%20road%20at%20sunrise%20with%20a%20single%20traveller%2C%20hopeful%20warm%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-11&orientation=portrait",
    category: "电影",
    episode: "高清完整版",
    score: "9.1",
    time: "5 小时前",
    tags: ["剧情", "公路"],
  },
  {
    id: "u12",
    title: "心动信号局",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20stylized%20movie%20poster%20of%20a%20bright%20colorful%20studio%20set%20with%20warm%20festive%20lights%20and%20playful%20shapes%2C%20cheerful%20moody%20lighting%2C%20rich%20color%20grading%2C%20simple%20deep%20toned%20gradient%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=420&height=580&seq=jj-upd-12&orientation=portrait",
    category: "综艺",
    episode: "更新至 7 期",
    score: "8.0",
    time: "6 小时前",
    tags: ["真人秀", "情感"],
  },
];